import { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, GuestRating, ArrowLink } from '@bwoty-web/ui-kit';
import SlideRating from './SlideRating';
import { logGeoInformation } from '../../../utils/log';

import './Ratings.scss';

const Ratings = ({
  heading,
  labels,
  averageGuestRating,
  categoryRatings,
  numberOfVotes,
}) => {
  const [showRatingModal, setShowRatingModal] = useState(false);
  const basedOnRatingText = labels.basedOnRatingText.replace(
    '{numberOfVotes}',
    numberOfVotes,
  );
  const remainingCategoryRatings = categoryRatings?.filter(
    (rating) => !['resortRating', 'numberOfAnswers'].includes(rating?.id),
  );
  const hasGuestRating = !!averageGuestRating && averageGuestRating !== 0;

  return (
    <div className="gw-ratings">
      <h2 className="gw-ratings__guest-title">{heading}</h2>
      {hasGuestRating && (
        <GuestRating
          className="gw-ratings__guest-rating"
          onClick={() => {
            setShowRatingModal(true);
            logGeoInformation.clickOnGuestRating();
          }}
          rating={averageGuestRating}
          numberOfAnswers={numberOfVotes}
          beforeNumberOfAnswers={labels.guestRatingCountBefore}
          afterNumberOfAnswers={labels.guestRatingCountAfter}
          showLabel
          showScale
        />
      )}
      {remainingCategoryRatings && remainingCategoryRatings?.length > 0 ? (
        <div className="gw-ratings__category-ratings">
          {remainingCategoryRatings
            ?.slice()
            .sort((a, b) => {
              if (a.rating === b.rating) {
                return false;
              }
              return a.rating < b.rating ? 1 : -1;
            })
            .slice(0, 3)
            .map((category) => {
              return (
                <SlideRating
                  rating={category?.rating}
                  title={category?.title}
                  key={category?.id}
                />
              );
            })}
          <ArrowLink
            className="gw-ratings__guest-more-ratings"
            onClick={() => {
              setShowRatingModal(true);
              logGeoInformation.clickOnMoreRatings();
            }}
          >
            {labels.moreRatingsText}
          </ArrowLink>
        </div>
      ) : (
        <div className="gw-ratings__guest-traveltip">
          <p className="gw-ratings__guest-traveltip-text">
            {labels.travelTipText}
          </p>
        </div>
      )}

      <Modal
        size="s"
        onClose={() => setShowRatingModal(false)}
        isOpen={showRatingModal}
        heading={heading}
      >
        <div className="gw-ratings-popup-content">
          <div className="gw-ratings-popup-content__guest-rating">
            {hasGuestRating && (
              <GuestRating rating={averageGuestRating} showScale />
            )}
            {basedOnRatingText}
          </div>
          {remainingCategoryRatings && (
            <div className="gw-ratings-popup-content__category-ratings">
              {remainingCategoryRatings?.map((category) => {
                return (
                  <SlideRating
                    key={category?.id}
                    rating={category?.rating}
                    title={category?.title}
                  />
                );
              })}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

Ratings.propTypes = {
  heading: PropTypes.string.isRequired,
  labels: PropTypes.shape({
    basedOnRatingText: PropTypes.string,
    guestRatingCountBefore: PropTypes.string,
    guestRatingCountAfter: PropTypes.string,
    moreRatingsText: PropTypes.string,
    travelTipText: PropTypes.string,
  }).isRequired,
  averageGuestRating: PropTypes.number,
  numberOfVotes: PropTypes.string,
  categoryRatings: PropTypes.arrayOf(PropTypes.shape({})),
};

Ratings.defaultProps = {
  averageGuestRating: 0,
  categoryRatings: [],
  numberOfVotes: '',
};

export default Ratings;
